import script from "./Scheduler.vue?vue&type=script&lang=ts&setup=true"
export * from "./Scheduler.vue?vue&type=script&lang=ts&setup=true"

import "./Scheduler.vue?vue&type=style&index=0&id=1a397cd8&lang=scss"
import "./Scheduler.vue?vue&type=style&index=1&id=1a397cd8&lang=scss&scoped=true"
script.__scopeId = "data-v-1a397cd8"

export default script